/**
 * Domain TLD page (/domeniu-ro, /domeniu-com etc.) — migrated from
 * public/js/domain.js.
 *
 * 1. Search form: AJAX domain lookup → replace .search-result template
 * 2. Switch button: alternate intre 2 mod-uri (search / add domain) cu
 *    schimbare de placeholder + button text
 */
import { Resort } from '../core/resort.js';

interface DomainResp {
    status: string;
    domain?: string;
    url?:    string;
    price?:  string;
}

new Resort(() => {
    const srClone = ($('.search-result') as Element | null)?.cloneNode(true) as HTMLElement | null;
    if (!srClone) return;
    srClone.classList.remove('hide');

    const searchForm = $('header form.search') as HTMLFormElement | null;
    if (!searchForm) return;

    searchForm.Form('domains', 'single_domain_info', {}, {
        valid: () => ({ fqdn: 'nn()' }),
        done: (rsp: unknown, data: unknown) => {
            const sr = $('.search-result') as HTMLElement | null;
            if (!sr) return;
            sr.html('');
            const srTmp = srClone.cloneNode(true) as HTMLElement;
            if (rsp === 'Done') {
                const d = data as DomainResp;
                srTmp.find('.dom-status', (st: Element) => { (st as HTMLElement).style.display = 'none'; return true; });
                const box = srTmp.find(`.st-${d.status}`) as HTMLElement | null;
                if (box) {
                    box.style.display = 'block';
                    let content = box.html() as string;
                    if (d.domain) content = content.replace('#domain', d.domain);
                    if (d.url)    content = content.replace('#url',    d.url);
                    if (d.price)  content = content.replace('#price',  d.price);
                    box.html(content);
                    sr.replaceWith(srTmp);
                }
            }
        },
    }, { loader: true });

    /* Switch mode (search / add domain) */
    const is_en = /\/en\//.test(window.location.href);
    const input  = searchForm.find('input[name="fqdn"]') as HTMLInputElement | null;
    const button = searchForm.find('button[type="submit"]') as HTMLButtonElement | null;
    if (!input || !button) return;

    ($('.switch-btn') as Element | null)?.on('click', 'a', function (this: Element) {
        if (this.classList.contains('active')) return;
        ($('.switch-btn a.active') as Element | null)?.classList.remove('active');
        this.classList.add('active');

        const id = (this as HTMLElement).dataset['id'];
        const modeInput = searchForm.find('input[name="mode"]') as HTMLInputElement | null;
        if (modeInput) modeInput.value = id ?? '';

        if (id === '1') {
            input.setAttribute('placeholder', is_en ? 'Find your perfect domain name' : 'Caută domeniul perfect');
            const span = button.find('span') as HTMLElement | null;
            if (span) span.textContent = is_en ? 'SEARCH' : 'CAUTĂ';
        } else {
            input.setAttribute('placeholder', is_en ? 'Add domain' : 'Adaugă domeniul');
            const span = button.find('span') as HTMLElement | null;
            if (span) span.textContent = 'GO';
        }
    });
});
